import React, { FC } from 'react';
import classes from './style/index.module.scss';
import { PaddingBox } from '../../../../../../../ReactSharedScripts/components/PaddingBox';
import { Typography } from '../../../../../../../ReactSharedScripts/components/Typography';

export const PublicJobDetailSimilarJobsContainer: FC<React.PropsWithChildren<{ title?: string }>> = ({
	children,
	title,
}) => {
	return (
		<section>
			<PaddingBox bottomNormal>
				<Typography
					headingSize={2}
					bold
				>
					{title}
				</Typography>
			</PaddingBox>
			<div className={classes.cardList}>{children}</div>
		</section>
	);
};
